module.exports = __webpack_public_path__ + "./img/logo.77428615f22a16c857ac5909b0b69364.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = ./src/assets/logo.jpg
// module chunks = 0